import type { DesktopChartLayoutMode } from "@/lib/desktop-layout/store";
import type { ChartPanelId } from "@/vybe-trader-client/chart/stores/chartPanelTypes";

/** Panel ids rendered for each desktop chart layout (matches DesktopChartArea). */
export function getVisibleChartPanelIds(
  mode: DesktopChartLayoutMode,
): ChartPanelId[] {
  switch (mode) {
    case "single":
      return [0];
    case "two-horizontal":
    case "two-vertical":
      return [0, 1];
    case "quad":
      return [0, 1, 2, 3];
    default:
      return [0];
  }
}
